import React, { useEffect, useState } from 'react';
import { FiTag } from 'react-icons/fi';
import { HiArrowNarrowLeft } from 'react-icons/hi';
import { Button, Modal } from 'src/components';
import { DashboardLayout } from 'src/containers';
import { formatMoney } from 'src/utils';
import Card from './components/Card';
import { useLocation, useParams } from 'react-router-dom';
import FieldDetail from 'src/components/FieldDetail';
import items from '../items/items';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import useFetch from 'src/hooks/useFetch';
import Loader from 'src/components/loader';
import RefundModal from './RefundModal';
import DateFormat from 'src/components/DateFormat';
import { useDispatch } from 'react-redux';
import { setDashLayoutHeading } from 'src/redux/action/dashLayoutHeading.action';
import { CurrencyAmount } from 'src/containers/currency';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/reducers';

interface IProps {}

const ReceiptRefund: React.FC<IProps> = ({}) => {
  const dispatch = useDispatch();
  const symbol = useSelector(
    ({ currencyData }: RootState) => currencyData.myCurrencyData?.symbol ?? 'Rs.'
  );

  const [isLoading, setIsLoading] = useState(false);
  const [singleReceiptData, setSingleReceiptData] = useState<any>([]);
  const [showModal, setShowModal] = React.useState(false);
  const { id } = useParams();
  const handleModal = () => {
    setShowModal(!showModal);
  };

  const fetchSingleReceiptData = async () => {
    setIsLoading(true);
    try {
      const res = await Service.get(`/payments/receipt/${id}`);
      const data = await res?.data;
      setSingleReceiptData([data]);
      setIsLoading(false);
    } catch (err) {}
  };

  useEffect(() => {
    fetchSingleReceiptData();
  }, []);

  // assign the dashboard layout to the page
  React.useEffect(() => {
    dispatch(
      setDashLayoutHeading(
        `#${singleReceiptData && singleReceiptData[0]?.referenceNumber}`
      )
    );
  }, [singleReceiptData]);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2"></div>
            <div className=" flex  items-center space-x-3">
              <p
                className={`${
                  singleReceiptData[0]?.status === 'partially_refunded'
                    ? 'text-primary border border-primary '
                    : singleReceiptData[0]?.status === 'completed'
                    ? 'text-success border border-success'
                    : singleReceiptData[0]?.status === 'refunded'
                    ? 'text-warning border border-warning'
                    : ''
                }  text-sm w-[135px] rounded-xl capitalize py-2  px-2 text-center`}
              >
                {singleReceiptData[0]?.status}
              </p>
              {singleReceiptData[0]?.status != 'refunded' && (
                <Button
                  text="refund"
                  variant="outline"
                  className="px-10"
                  onClick={() => setShowModal(!showModal)}
                />
              )}
            </div>
          </div>

          <div className="flex w-full ">
            <div className="w-1/2  mr-20">
              <div className="mt-5 text-light-grey font-semibold capitalize">
                <p>Order Details</p>
                <div
                  title="order details "
                  className="border-[1px] border-light-grey  mt-5  rounded-lg w-full"
                >
                  <div className=" mb-3 w-full ">
                    <FieldDetail title={'Date'}>
                      {singleReceiptData && (
                        <DateFormat text={singleReceiptData[0]?.createdAt} />
                      )}
                    </FieldDetail>

                    <FieldDetail title={'Customer'}>
                      {singleReceiptData &&
                        singleReceiptData[0]?.customer?.name}
                    </FieldDetail>
                    <FieldDetail title={'Cashier'}>
                      {singleReceiptData &&
                        singleReceiptData[0]?.employee?.name}
                    </FieldDetail>
                    <FieldDetail title={'Origin'} className={'px-3'}>
                      {singleReceiptData && singleReceiptData[0]?.origin?.name}
                    </FieldDetail>
                    <FieldDetail title={'Order Type'} className={'px-3'}>
                      {singleReceiptData && singleReceiptData[0]?.orderType}
                    </FieldDetail>
                  </div>
                </div>
              </div>
              <div className="mt-5 text-light-grey font-semibold capitalize">
                <p>Payment Details</p>
                <div
                  title="order details "
                  className="border-[1px] border-light-grey  mt-5  rounded-lg "
                >
                  <div className=" mb-3">
                    <FieldDetail title={'Amount '}>
                      {symbol}
                    </FieldDetail>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-1/2">
              <div className="mt-6 col-span-5 mb-5  text-light-grey font-semibold capitalize">
                <p>Order List</p>
                <Card title="" className="w-[352px] h-fit  rounded-b-none px-2">
                  <div title="" className="">
                    {singleReceiptData[0]?.items?.map((item: any) => {
                      return (
                        <div
                          key={item.itemId}
                          className=" py-1 px-2 border-b-2  border-border-color-dark"
                        >
                          <div className="flex justify-between py-2 px-4 text-black">
                            <p className="font-semibold text-base ">
                              {item.itemName}
                            </p>
                            {item?.isRefunded && (
                              <p className="text-warning">Refunded</p>
                            )}
                            <p className="text-base font-normal  ">
                              <CurrencyAmount amount={item.price}/>
                            </p>
                          </div>
                          {item.modifiers.map((modifier: any) => {
                            return (
                              <div key={modifier.id}>
                                <ul>
                                  {modifier.options.map((option: any) => {
                                    return (
                                      <li key={option.id}>
                                        <div className="flex justify-between py-2 px-4 text-[#949CC0]">
                                          <p>{option.name}</p>
                                          <p><CurrencyAmount amount={option.price}/></p>
                                        </div>
                                      </li>
                                    );
                                  })}
                                </ul>
                              </div>
                            );
                          })}
                        </div>
                      );
                    })}
                  </div>
                  <div className="rounded-xl rounded-t-none  border border-border-color border-t-0 p-4 bg-pure-white ">
                    <div className="flex justify-between  py-1 px-2">
                      <p className=" text-secondary-0">Total</p>
                      <p className=" text-black">
                        <CurrencyAmount amount={singleReceiptData[0]?.total}/>
                      </p>
                    </div>
                  </div>
                </Card>

                <div className=" w-full mt-3"></div>
              </div>
            </div>
          </div>
        </>
      )}
      {showModal && (
        <RefundModal
          singleReceiptData={singleReceiptData && singleReceiptData}
          handleModal={handleModal}
          showModal={showModal}
        />
      )}
    </>
  );
};

export default React.memo(ReceiptRefund);
